import * as R from 'ramda'

export const getModifiedFields = (original: Record<string, any>, modified: Record<string, any>) => {
  return R.pickBy(
    (value, key) => !R.equals(value, original[key]),
    modified,
  )
}
